import { useDbmsList } from '@nx/state/desktop';
import { isNotNullish } from '@nx/stdlib';

export const useHasV1InstanceBeenCloned = () => {
  const { dbmss } = useDbmsList();
  const clonedDbmsIds = new Set(
    dbmss
      .filter((dbms) => isNotNullish(dbms.metadata?.desktopV1SourceDbmsId))
      .map((dbms) => String(dbms.metadata?.desktopV1SourceDbmsId)),
  );

  return {
    hasV1InstanceBeenCloned: (v1DbmsId: string) => clonedDbmsIds.has(v1DbmsId),
  };
};
